// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";

function PazeWallet(props) {
  let logger = props.logger;
  React.useEffect(() => {
    let handle = ev => {
      let json = Utils$OrcaPaymentPage.safeParse(ev.data);
      let metaData = Utils$OrcaPaymentPage.getDictFromDict(Utils$OrcaPaymentPage.getDictFromJson(json), "metadata");
      if (Utils$OrcaPaymentPage.getString(metaData, "wallet", "") !== "Paze") {
        return;
      }
      let clientId = Utils$OrcaPaymentPage.getString(metaData, "clientId", "");
      let clientName = Utils$OrcaPaymentPage.getString(metaData, "clientName", "");
      let clientProfileId = Utils$OrcaPaymentPage.getString(metaData, "clientProfileId", "");
      let sessionId = Utils$OrcaPaymentPage.getString(metaData, "sessionId", "");
      let publishableKey = Utils$OrcaPaymentPage.getString(metaData, "publishableKey", "");
      let emailAddress = Utils$OrcaPaymentPage.getString(metaData, "emailAddress", "");
      let transactionAmount = Utils$OrcaPaymentPage.getString(metaData, "transactionAmount", "");
      let transactionCurrencyCode = Utils$OrcaPaymentPage.getString(metaData, "transactionCurrencyCode", "");
      let componentName = Utils$OrcaPaymentPage.getString(metaData, "componentName", "");
      let mountPazeSDK = () => {
        let pazeScriptURL = publishableKey.startsWith("pk_snd") ? `https://sandbox.digitalwallet.earlywarning.com/web/resources/js/digitalwallet-sdk.js` : `https://checkout.paze.com/web/resources/js/digitalwallet-sdk.js`;
        let loadPazeSDK = async param => {
          try {
            await window.DIGITAL_WALLET_SDK.initialize({
              client: {
                id: clientId,
                name: clientName,
                profileId: clientProfileId
              }
            });
            let canCheckout = await window.DIGITAL_WALLET_SDK.canCheckout({
              emailAddress: emailAddress
            });
            let transactionValue = {
              transactionAmount: transactionAmount,
              transactionCurrencyCode: transactionCurrencyCode
            };
            await window.DIGITAL_WALLET_SDK.checkout({
              acceptedPaymentCardNetworks: [
                "VISA",
                "MASTERCARD"
              ],
              emailAddress: canCheckout.consumerPresent ? emailAddress : "",
              sessionId: sessionId,
              actionCode: "START_FLOW",
              transactionValue: transactionValue,
              shippingPreference: "ALL"
            });
            let completeObj_transactionOptions = {
              billingPreference: "ALL",
              merchantCategoryCode: "US",
              payloadTypeIndicator: "PAYMENT"
            };
            let completeObj = {
              transactionOptions: completeObj_transactionOptions,
              transactionId: "",
              sessionId: sessionId,
              transactionType: "PURCHASE",
              transactionValue: transactionValue
            };
            let completeResponse = await window.DIGITAL_WALLET_SDK.complete(completeObj);
            Utils$OrcaPaymentPage.messageParentWindow(undefined, [
              [
                "fullscreen",
                false
              ],
              [
                "isPaze",
                true
              ],
              [
                "componentName",
                componentName
              ],
              [
                "completeResponse",
                Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(completeResponse), "completeResponse", "")
              ]
            ]);
            return Promise.resolve();
          } catch (raw_err) {
            let err = Primitive_exceptions.internalToException(raw_err);
            logger.setLogError(JSON.stringify(Utils$OrcaPaymentPage.formatException(err)), "PAZE_SDK_FLOW", undefined, undefined, "ERROR", undefined, "PAZE");
            Utils$OrcaPaymentPage.messageParentWindow(undefined, [
              [
                "fullscreen",
                false
              ],
              [
                "isPaze",
                true
              ],
              [
                "flowExited",
                "stop"
              ],
              [
                "componentName",
                componentName
              ]
            ]);
            return Promise.resolve();
          }
        };
        logger.setLogInfo("PAZE SDK Script Loading", "PAZE_SDK_FLOW", undefined, undefined, undefined, undefined, undefined);
        let pazeScript = document.createElement("script");
        pazeScript.src = pazeScriptURL;
        pazeScript.onerror = exn => logger.setLogError(`Error During Loading PAZE SDK Script: ` + JSON.stringify(exn), "PAZE_SDK_FLOW", undefined, undefined, undefined, undefined, undefined);
        pazeScript.onload = () => {
          logger.setLogInfo("PAZE SDK Script Loaded", "PAZE_SDK_FLOW", undefined, undefined, undefined, undefined, undefined);
          loadPazeSDK();
        };
        document.body.appendChild(pazeScript);
      };
      if ([
          clientId,
          clientName,
          clientProfileId,
          sessionId,
          transactionCurrencyCode
        ].every(x => x !== "")) {
        return mountPazeSDK();
      }
    };
    window.addEventListener("message", handle);
    Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
        "iframeMountedCallback",
        true
      ]]);
    return () => {
      window.removeEventListener("message", handle);
    };
  }, []);
  return JsxRuntime.jsx("div", {
    className: "w-full flex flex-row justify-center rounded-md h-auto",
    id: "paze-button"
  });
}

let make = PazeWallet;

export {
  make,
}
/* react Not a pure module */
